export const BLOG_POSTS_LIMIT_WIDGET = 10;
